import { createRoutine } from 'redux-saga-routines';

export const fetchUserPermissions = createRoutine('FETCH_USER_PERMISSIONS');
